import { render, staticRenderFns } from "./sampleSsoSignIn.vue?vue&type=template&id=0339343f"
import script from "./sampleSsoSignIn.vue?vue&type=script&lang=js"
export * from "./sampleSsoSignIn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports